import { useGetTicketsQuery } from "features/tickets/ticketApi.slice";

export const useNewestTickets = () => {
  const { data, isLoading, isFetching } = useGetTicketsQuery();
  return { newestTickets: data, isLoading: isLoading || isFetching };
};
